// External Dependencies
import { useQuery } from '@tanstack/react-query';

// Internal Dependencies
import { prestoAdminApiClient } from 'utils/api/apiClient';

export const useGetAllInventoryVendors = () => {
  return useQuery({
    queryFn: () => prestoAdminApiClient.v1.inventoryVendors.getAll(),
    queryKey: ['getAllInventoryVendors'],
  });
};
